import React from 'react';
const {strategySummary}=require('./customerBoardPresentation');
export default function StrategyIntro({strategy,board}){
 return <p className="strategy-intro">{strategySummary(strategy,board)}</p>;
}
